import { Heading, Stack } from 'braid-design-system';
import type React from 'react';
import { Helmet } from 'react-helmet-async';



export type Title =
  | 'Sign in'
  | 'Register'
  | 'Register as an employer'
  | 'Forgot password'
  | 'Expired password'
  | 'Reset password'
  | 'Activate account'
  | 'Check your email for a code';

type HeadingProps = React.ComponentProps<typeof Heading>;

interface FormHeaderProps {
  title?: Title;
  renderTitle?: boolean;
  titleAlignment?: HeadingProps['align'];
  titleLevel?: HeadingProps['level'];
}

const FormHeader = ({
  title,
  renderTitle = true,
  titleAlignment,
  titleLevel = '1',
}: FormHeaderProps) => {

  const experienceTitles = {
    business: 'Sign In - SEEK' as const,
    candidate: 'Candidate Sign In - SEEK' as const,
    hirer: 'Employer Sign In - SEEK' as const,
  };

  const experienceDescriptions = {
    business:
      'Find a Business or Franchise for sale. SEEK Business offers you the unique opportunity of owning & managing your own business.' as const,
    candidate:
      'Sign in to view and manage your saved jobs, apply for new jobs and streamline your job seeking process.' as const,
    hirer:
      'Find your next hire on Australia’s largest employment marketplace! With 96 roles filled hourly, we place more people in more jobs. Login &amp; start finding talent.' as const,
  };

  return (
    <Stack space="none">
      {(() => {
        switch (title) {
          case 'Sign in':
            return (
              <Helmet>
                <title>
                  {experienceTitles.candidate}
                </title>
                <meta
                  name="description"
                  content={experienceDescriptions.candidate}

                />
              </Helmet>
            );
        }
      })()}

      {renderTitle && title && (
        <Heading align={titleAlignment} level={titleLevel}>
          {experienceTitles.candidate}
        </Heading>
      )}
    </Stack>
  );
};

export default FormHeader;
